import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-surveys',
  templateUrl: './surveys.component.html',
  styleUrls: ['./surveys.component.css']
})
export class SurveysComponent implements OnInit {

  @Input() surveys;
  @Input() filterargs;
  @Input() showNumber = 10;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/gdb/Documents/work/garrido-angular/garrido-front/src/app/surveys/surveys.component.ts